import { render } from "./RequestVideo.vue?vue&type=template&id=6597f706&scoped=true"
import script from "./RequestVideo.vue?vue&type=script&lang=js"
export * from "./RequestVideo.vue?vue&type=script&lang=js"

import "./RequestVideo.vue?vue&type=style&index=0&id=6597f706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6597f706"]])

export default __exports__